import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["title", "titleId", "subtitle", "subtitleId", "sticky", "onClose", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'components/Box';
import Button from 'components/Button';
import StickyBox from 'components/StickyBox';
import Panel from 'components/Panel';
import PageTitle from 'components/PageTitle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ModalCloseButton(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  return /*#__PURE__*/_jsx(Button, {
    position: "absolute",
    top: "xxs",
    right: "xxs",
    icon: "x",
    variant: "transparent",
    size: "large",
    onClick: onClick,
    title: t('actions_close_modal')
  });
}
function ModalHeadingPanel(_ref2) {
  var children = _ref2.children,
    sticky = _ref2.sticky,
    onClose = _ref2.onClose;
  var Wrapper = sticky ? StickyBox : Box;
  return /*#__PURE__*/_jsxs(Wrapper, {
    as: Panel,
    forwardedAs: "header",
    position: sticky ? undefined : 'relative',
    borderTopRadius: "inherit",
    children: [/*#__PURE__*/_jsx(Box, {
      pr: 64,
      children: children
    }), onClose && /*#__PURE__*/_jsx(ModalCloseButton, {
      onClick: onClose
    })]
  });
}
function ModalHeadline(_ref3) {
  var title = _ref3.title,
    titleId = _ref3.titleId,
    subtitle = _ref3.subtitle,
    subtitleId = _ref3.subtitleId,
    sticky = _ref3.sticky,
    onClose = _ref3.onClose,
    children = _ref3.children,
    otherProps = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_jsxs(ModalHeadingPanel, {
    sticky: sticky,
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(PageTitle, _objectSpread(_objectSpread({}, otherProps), {}, {
      id: titleId,
      children: title || children
    })), subtitle && /*#__PURE__*/_jsx(Box, {
      dimmed: true,
      id: subtitleId,
      pt: "xxs",
      children: subtitle
    })]
  });
}
export { ModalHeadingPanel, ModalCloseButton };
export default ModalHeadline;